import { AHSeparator, AHText, Box, ListItem } from "arkh";
import React from "react";
import { WidgetEmployeeLeaveSettingsStackScreenProps } from "./WidgetEmployeeLeaveSettingsStack";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { LazyQueryNetworkBoundrary } from "@/src/components/mobile/QueryNetworkBoundrary";
import { FormattedMessage } from "react-intl";
import { useWidgetSettingsEmployeeLeaveContext } from "./WidgetEmployeeLeaveSettingsContext";

import { graphql, useLazyLoadQuery } from "react-relay";
import { WidgetEmployeeLeaveSettingsMainQuery } from "./__generated__/WidgetEmployeeLeaveSettingsMainQuery.graphql";
import { ManageEmployeeSchedueTypesListItem } from "../ManageEmployeeSchedueTypesListItem";

function WidgetEmployeeLeaveSettingsMainC(props: {
  fetchKey: string;
  onTeamPress: () => void;
  onLeaveCodePress: () => void;
  onEmployeeScheduleTypePress: () => void;
}) {
  const data = useLazyLoadQuery<WidgetEmployeeLeaveSettingsMainQuery>(
    graphql`
      query WidgetEmployeeLeaveSettingsMainQuery {
        store {
          myRole
          ...ManageEmployeeSchedueTypesListItem_store
        }
      }
    `,
    {},
    {
      fetchKey: props.fetchKey,
      fetchPolicy: "store-and-network",
    }
  );
  const { store } = data;
  const { teamIds, leaveReasonIds } = useWidgetSettingsEmployeeLeaveContext();
  const intl_tokens = useIntlTokens();
  return (
    <Box spaceHorizontal="medium" spaceTop="medium">
      {data.store.myRole === "ADMIN" ? (
        <Box spaceBottom="medium">
          <ManageEmployeeSchedueTypesListItem
            store={store}
            onPress={() => {
              props.onEmployeeScheduleTypePress();
            }}
          />
        </Box>
      ) : null}
      <ListItem
        isFirst
        onPress={() => {
          props.onTeamPress();
        }}
        right={
          <Box style={{ flexDirection: "row", alignItems: "center" }}>
            <AHText>
              {teamIds.length === 0 ? (
                intl_tokens.AllTeams
              ) : (
                <FormattedMessage
                  defaultMessage="{count, plural, one {# team} other {# teams}}"
                  description="WidgetEmployeeLeaveSettingsMain team count"
                  values={{ count: teamIds.length }}
                />
              )}
            </AHText>
            <ListItem.NavArrow />
          </Box>
        }
      >
        <ListItem.Title>{intl_tokens.Teams}</ListItem.Title>
      </ListItem>
      <AHSeparator />
      <ListItem
        isLast
        onPress={() => {
          props.onLeaveCodePress();
        }}
        right={
          <Box style={{ flexDirection: "row", alignItems: "center" }}>
            <AHText>
              {leaveReasonIds.length === 0 ? (
                intl_tokens.AllReasons
              ) : (
                <FormattedMessage
                  description="WidgetEmployeeLeaveSettingsMain leave code count"
                  defaultMessage="{count, plural, one {# reason} other {# reasons}}"
                  values={{ count: leaveReasonIds.length }}
                />
              )}
            </AHText>
            <ListItem.NavArrow />
          </Box>
        }
      >
        <ListItem.Title>{intl_tokens.ReasonsForAbsence}</ListItem.Title>
      </ListItem>
    </Box>
  );
}

export function WidgetEmployeeLeaveSettingsMain(
  props: WidgetEmployeeLeaveSettingsStackScreenProps<"WELSMain">
) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fk) => (
        <WidgetEmployeeLeaveSettingsMainC
          fetchKey={fk}
          onTeamPress={() => {
            props.navigation.navigate("WELSTeams", {});
          }}
          onLeaveCodePress={() => {
            props.navigation.navigate("WELSLeaveReasons", {});
          }}
          onEmployeeScheduleTypePress={() => {
            props.navigation.navigate("EmployeeScheduleEdit", {
              screen: "EmployeeScheduleEditScheduleTypesScreen",
              params: {},
            });
          }}
        />
      )}
    </LazyQueryNetworkBoundrary>
  );
}
